export const FETCH_SUGGESTED_TOPICS_FAILURE =
	'state.actions.fetch-suggested-topics-failure.FETCH_SUGGESTED_TOPICS_FAILURE' as const;

export type FetchSuggestedTopicsFailurePayload = {};
export type FetchSuggestedTopicsFailureAction = {
	type: typeof FETCH_SUGGESTED_TOPICS_FAILURE;
	payload: FetchSuggestedTopicsFailurePayload;
};

export const fetchSuggestedTopicsFailure = (
	payload: FetchSuggestedTopicsFailurePayload,
): FetchSuggestedTopicsFailureAction => ({
	type: FETCH_SUGGESTED_TOPICS_FAILURE,
	payload,
});
